import { actions } from '../actions';
import { reduxSwitch } from '../../../tools';

const defaultState = {
	preview: null,
	list: null,
	uri: null,
	parameters: null,
	hasMore: null,
	pending: false,
	error: null,
	at: null,
	// export
	exporting: false,
	progress: null, // { percent, done, total }
	csv: null,
};

const updateAnchor = (parameters, entries) => {
	if (entries) parameters.anchorOn(entries);
	return parameters;
}

function apiReducer(state, action) {
	let _state;
	switch (action.type) {
		case actions.ridership.request.type:
			if (action.clear) {
				_state = { ...defaultState };
			} else {
				_state = {...state};
			}
			return {
				..._state,
				uri: action.uri,
				parameters: action.parameters,
				pending: true,
				error: null,
				at: action.clear ? new Date() : _state.at
			};
		case actions.ridership.success.type:
			const entries = action.report && action.report.entries;
			const hasMore = entries ? entries.length > 0 : false;
			const list = state.list ? (entries ? state.list.concat(entries) : state.list) : (entries ? [...entries] : []);;
			_state = {...state};
			return {
				..._state,
				list,
				parameters: updateAnchor(state.parameters, entries),
				hasMore,
				pending: false
			};
		case actions.ridership.fail.type:
			return {
				...state,
				pending: false,
				error: action.errorMessage
			};
		case actions.ridership.cancel.type:
			return {
				...state,
				pending: false
			};
		default:
			return state;
	}
}

function exportReducer(state, action) {
	switch (action.type) {
		case actions.ridership.export.type:
			return {
				...state,
				exporting: true,
				progress: null,
				csv: null
			}
		case actions.ridership.exportProgress.type:
			return {
				...state,
				progress: {
					percent: action.progress,
					done: action.count,
					total: action.total
				}
			}
		case actions.ridership.exportDone.type:
			return {
				...state,
				parameters: state.parameters,
				exporting: false,
				csv: action.csv
			}
		case actions.ridership.exportClear.type:
			return {
				...state,
				csv: null
			}
		default:
			return state;
	}

}

const reducer = reduxSwitch([apiReducer, exportReducer], defaultState);

export { reducer };
